import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import TransitionLinkUnstyled from 'gatsby-plugin-transition-link'
import posed from 'react-pose'
// import { redirectTo } from '@reach/router'

const headerStates = {
  show: {
    opacity: 1,
  },
  hide: {
    opacity: 0.3,
  },
}

const paneStates = {
  open: {
    background: 'rgba(246, 246, 246, 1)',
    height: 400,
  },
  closed: {
    background: 'rgba(246, 246, 246, 0)',
    height: 300,
    applyAtEnd: { height: 100 },
  },
}

const coverStates = {
  open: {
    applyAtStart: { display: 'block' },
    opacity: 1,
  },
  closed: {
    applyAtEnd: { display: 'none' },
    opacity: 0,
  },
}

const linksTransitionStates = {
  open: {
    applyAtStart: { display: 'block' },
    opacity: 1,
    y: 0,
  },
  closed: {
    applyAtEnd: { display: 'none' },
    opacity: 0,
    y: -25,
  },
}

// const indicatorWrapperStates = {
//   home: {
//     y: -102,
//     opacity: 1,
//     transition: {
//       type: 'spring',
//       stiffness: 200,
//       damping: 50,
//     },
//   },
//   writing: {
//     y: -102 + 1 * 28,
//     opacity: 1,
//     transition: {
//       type: 'spring',
//       stiffness: 200,
//       damping: 50,
//     },
//   },
//   photography: {
//     y: -102 + 2 * 28,
//     opacity: 1,
//     transition: {
//       type: 'spring',
//       stiffness: 200,
//       damping: 50,
//     },
//   },
//   bookshelf: {
//     y: -102 + 3 * 28,
//     opacity: 1,
//     transition: {
//       type: 'spring',
//       stiffness: 200,
//       damping: 50,
//     },
//   },
// }

// const indicatorStates = {
//   initial: {
//     scale: 0.025,
//     opacity: 0,
//     x: 0,
//   },
//   samesame: {
//     scale: 0.1,
//     opacity: 1,
//     x: 10,
//   },
//   press: {
//     scale: 0.1,
//     opacity: 0.1,
//   },
// }

// const arrowStates = {
//   initial: {
//     opacify: 1,
//     fill: '#4f4f4f',
//     x: 0,
//   },
//   samesame: {
//     opacify: 0.5,
//     fill: '#ffffff',
//     x: 10,
//   },
//   press: {
//     fill: '#ffffff',
//   },
// }

const barOneStates = {
  open: {
    rotate: '45deg',
    y: 3,
  },
  closed: {
    rotate: '0deg',
    y: 0,
  },
}

const barTwoStates = {
  open: {
    rotate: '-45deg',
    y: -4,
  },
  closed: {
    rotate: '0deg',
    y: 0,
  },
}

const StyledHeader = styled(posed.div(headerStates))`
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  transition: opacity 0.3s ease-out;
  :hover {
    opacity: 1 !important;
  }
  @media (max-width: 1000px) {
    background: rgba(246, 247, 248, 0.85);
    opacity: 1 !important;
  }
`

const HeaderPane = styled(posed.div(paneStates))`
  padding: 3rem 5rem 0;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  z-index: 2;
  @media (max-width: 1650px) {
    padding: 2rem 2rem;
  }
  @media (max-width: 1000px) {
    padding-top: 1.8rem;
  }
`

const HeaderCover = styled(posed.div(coverStates))`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(174, 174, 174, 0.5);
  z-index: -15;
  opacity: 0;
  display: none;
`

const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 36px;
`

const TransitionLink = styled(TransitionLinkUnstyled)`
  display: block;
  text-decoration: none;
  color: #171d20;
  font-size: 22px;
  line-height: 2;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  text-align: right;
  color: #4f4f4f;
  :visited {
    color: #4f4f4f;
  }
  &:hover {
    opacity: 0.5;
  }
`

const NavLinks = styled(posed.div(linksTransitionStates))`
  height: 100%;
  /* background-color: rgba(246, 247, 248, 0.5); */
  padding: 0rem;
  margin-top: 2.8rem;
  display: none;
`

// const Indicator = styled(posed.div(indicatorStates))`
//   position: relative;
//   left: -128px;
//   right: 0;
//   top: -136px;
//   transform: translate(0, -50%);
//   width: 280px;
//   height: 280px;
//   border-radius: 50%;
//   opacity: 0;
//   background: linear-gradient(135deg, #4f4f4f 0%, #4f4f4f 100%);
// `

// const Arrow = styled(posed.svg(arrowStates))`
//   width: 15px;
//   height: 15px;
//   opacity: 1;
// `

// const ArrowWrapper = styled.div`
//   position: absolute;
//   left: 5px;
//   right: 0;
//   top: 0;
//   transform: translate(0, -50%);
//   width: 15px;
//   height: 15px;
// `

// const IndicatorWrapper = styled(posed.div(indicatorWrapperStates))`
//   width: 7px;
//   height: 7px;
//   position: relative;
//   left: 140px;
//   z-index: 1;
//   opacity: 0;
// `

const MenuButton = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 20px;
  margin-top: 8px;
  justify-content: center;
  :hover {
    cursor: pointer;
  }
`

const BarOne = styled(posed.div(barOneStates))`
  width: 20px;
  height: 2px;
  margin-bottom: 5px;
  background-color: #4f4f4f;
  transition: all 0.2s ease-out;
  ${MenuButton}:hover & {
    background-color: #8d8d8d;
  }
`

const BarTwo = styled(posed.div(barTwoStates))`
  width: 20px;
  height: 2px;
  background-color: #4f4f4f;
  transition: all 0.2s ease-out;
  ${MenuButton}:hover & {
    background-color: #8d8d8d;
  }
`

const Logo = styled.a`
  height: 36px;
`

class Header extends React.Component {
  constructor(props) {
    super(props)
    let path
    if (typeof window !== `undefined`) {
      path = window.location.pathname.replace(/\//g, '')
      if (path === '') {
        path = 'home'
      }
    } else {
      path = 'home'
    }

    this.state = {
      position: path,
      hoverScale: 'initial',
      mouseEntered: false,
      latestPosition: path,
      headerOnScroll: 'show',
      headerOpen: false,
    }
    this.mouseEnter = this.mouseEnter.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)
    this.pressUp = this.pressUp.bind(this)
    this.pressDown = this.pressDown.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.toggleHeader = this.toggleHeader.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  toggleHeader() {
    this.setState({ headerOpen: !this.state.headerOpen })
  }

  handleScroll() {
    if (window.scrollY > 200) {
      this.setState({ headerOnScroll: 'hide' })
    } else {
      this.setState({ headerOnScroll: 'show' })
    }
  }

  mouseEnter() {
    this.setState({ hoverScale: 'samesame', mouseEntered: true })
  }

  mouseLeave() {
    if (this.state.latestPosition !== this.state.position) {
      this.setState({ position: this.state.latestPosition })
    }
    this.setState({ hoverScale: 'initial', mouseEntered: false })
  }

  pressDown() {
    this.setState({ hoverScale: 'press' })
  }

  pressUp() {
    this.setState({ hoverScale: 'samesame' })
  }

  setPosition(position) {
    this.toggleHeader()
    // this.setState({ position: position })
    // if (!this.state.mouseEntered) {
    //   this.setState({ position: position })
    // } else {
    //   this.setState({ latestPosition: position })
    //   this.setState({ position: position })
    // }
  }

  getTransitionStates(status) {
    if (['entering', 'entered'].includes(status)) {
      return ['visible', 'logoChain']
    } else if (['exiting'].includes(status)) {
      return 'exitedState'
    } else if (['exited'].includes(status)) {
      return 'startState'
    }
  }

  render() {
    return (
      <StyledHeader pose={this.state.headerOnScroll}>
        <HeaderPane pose={this.state.headerOpen ? 'open' : 'closed'}>
          <Logo href={'/'}>
            <svg width="30" height="36" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.0572 36H30L8.94279 0H0L21.0572 36ZM29.896 12.3429V0H21.0572C21.4732 3.90857 24.6967 11.3143 29.896 12.3429ZM0.103961 36H8.94279C8.52685 32.0914 5.30327 24.6857 0.103961 23.6571V36Z"
                fill="#4F4F4F"
              />
            </svg>
          </Logo>
          <HeaderRight>
            <MenuButton onClick={this.toggleHeader}>
              <BarOne pose={this.state.headerOpen} />
              <BarTwo pose={this.state.headerOpen} />
            </MenuButton>
            <NavLinks
              onMouseEnter={this.mouseEnter}
              onMouseLeave={this.mouseLeave}
              pose={this.state.headerOpen ? 'open' : 'closed'}
            >
              <div onMouseDown={this.pressDown} onMouseUp={this.pressUp}>
                <TransitionLink
                  to="/"
                  exit={{
                    length: 0.6,
                    zIndex: 2,
                    trigger: () => this.toggleHeader(),
                  }}
                  entry={{
                    delay: 0.6,
                    length: 0.4,
                  }}
                >
                  About
                </TransitionLink>
              </div>
              <div onMouseDown={this.pressDown} onMouseUp={this.pressUp}>
                <TransitionLink
                  to="/writing/"
                  exit={{
                    length: 0.6,
                    zIndex: 2,
                    trigger: () => this.toggleHeader(),
                  }}
                  entry={{
                    delay: 0.6,
                    length: 0.4,
                  }}
                >
                  Interface Notes
                </TransitionLink>
              </div>
              <div onMouseDown={this.pressDown} onMouseUp={this.pressUp}>
                <TransitionLink
                  to="/photography/"
                  exit={{
                    length: 0.6,
                    zIndex: 2,
                    trigger: () => this.toggleHeader(),
                  }}
                  entry={{
                    delay: 0.6,
                    length: 0.4,
                  }}
                >
                  Photography
                </TransitionLink>
              </div>
              <div onMouseDown={this.pressDown} onMouseUp={this.pressUp}>
                <TransitionLink
                  to="/bookshelf/"
                  exit={{
                    length: 0.6,
                    zIndex: 2,
                    trigger: () => this.toggleHeader(),
                  }}
                  entry={{
                    delay: 0.6,
                    length: 0.4,
                  }}
                >
                  Bookshelf
                </TransitionLink>
              </div>
              {/* <IndicatorWrapper pose={this.state.position}>
                <Indicator pose={this.state.hoverScale} />
                <ArrowWrapper>
                  <Arrow
                    pose={this.state.hoverScale}
                    viewBox="0 0 55 44"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M22.2388 44L-7.78586e-07 22L22.2388 0L26.306 4.02349L10.9328 19.1577H55V24.8423H10.9328L26.306 39.9765L22.2388 44Z" />
                  </Arrow>
                </ArrowWrapper>
              </IndicatorWrapper> */}
            </NavLinks>
          </HeaderRight>
        </HeaderPane>
        <HeaderCover
          pose={this.state.headerOpen ? 'open' : 'closed'}
          onClick={this.toggleHeader}
        />
      </StyledHeader>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: '',
}

export default Header
